export default __webpack_public_path__ + "static/media/phosphorous.be56e7ef.png";